import { Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  MAINTENANCE_SLA_TIMER_KINDS,
  type MaintenanceSlaSavedTimer,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';
import { useMaintenanceSlaReadTimerColumns } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaReadTimerColumns';

export interface MaintenanceSlaTimersReadProps {
  timers: MaintenanceSlaSavedTimer[];
}

export function MaintenanceSlaTimersRead({
  timers,
}: MaintenanceSlaTimersReadProps) {
  const { t } = useTranslation('sla');
  const columns = useMaintenanceSlaReadTimerColumns();

  if (timers.length === 0) {
    return (
      <Typography.Text>
        {t('oems.maintenance.sections.timers')}{' '}
        {t('oems.maintenance.timersNone')}
      </Typography.Text>
    );
  }

  const present = new Set(timers.map((timer) => timer.kind));
  const omitted = MAINTENANCE_SLA_TIMER_KINDS.filter(
    (kind) => !present.has(kind),
  );

  return (
    <>
      <Table
        size="small"
        pagination={false}
        rowKey="kind"
        dataSource={timers}
        columns={columns}
      />
      {omitted.length > 0 ? (
        <Typography.Text type="secondary">
          {t('oems.maintenance.omittedKinds', {
            kinds: omitted
              .map((kind) => t(`oems.maintenance.timerKind.${kind}`))
              .join(', '),
          })}
        </Typography.Text>
      ) : null}
    </>
  );
}
